/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Read_More_DescInputs */

const en_about_read_more_desc = /** @type {(inputs: About_Read_More_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in the github readme page`)
};

const ar_about_read_more_desc = /** @type {(inputs: About_Read_More_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`في صفحة README على GitHub`)
};

const bn_about_read_more_desc = /** @type {(inputs: About_Read_More_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`গিটহাব রিডমি পেজে`)
};

const de_about_read_more_desc = /** @type {(inputs: About_Read_More_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in der Github-Readme-Seite`)
};

const es_about_read_more_desc = /** @type {(inputs: About_Read_More_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`en la página Léame de github`)
};

const fr_about_read_more_desc = /** @type {(inputs: About_Read_More_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dans la page Lisez-moi de github`)
};

const pt_about_read_more_desc = /** @type {(inputs: About_Read_More_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`na página leia-me do github`)
};

const zh_about_read_more_desc = /** @type {(inputs: About_Read_More_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 GitHub 说明页`)
};

const tr_about_read_more_desc = /** @type {(inputs: About_Read_More_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`github benioku sayfasında`)
};

const ru_about_read_more_desc = /** @type {(inputs: About_Read_More_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`на странице readme github`)
};

const pl_about_read_more_desc = /** @type {(inputs: About_Read_More_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`na stronie readme Githuba`)
};

/**
* | output |
* | --- |
* | "in the github readme page" |
*
* @param {About_Read_More_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const about_read_more_desc = /** @type {((inputs?: About_Read_More_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Read_More_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_about_read_more_desc(inputs)
	if (locale === "bn") return bn_about_read_more_desc(inputs)
	if (locale === "de") return de_about_read_more_desc(inputs)
	if (locale === "es") return es_about_read_more_desc(inputs)
	if (locale === "fr") return fr_about_read_more_desc(inputs)
	if (locale === "pt") return pt_about_read_more_desc(inputs)
	if (locale === "zh") return zh_about_read_more_desc(inputs)
	if (locale === "tr") return tr_about_read_more_desc(inputs)
	if (locale === "ru") return ru_about_read_more_desc(inputs)
	if (locale === "pl") return pl_about_read_more_desc(inputs)
	return en_about_read_more_desc(inputs)
});